export { default } from './OfferHorizontalCard';
